(function (root) {
  'use strict';
  function recommend(catalog, cart, context) {
    if (!cart || cart.currency !== 'EUR' || !cart.items?.length) return {items: [], remaining: null};
    const present = new Set(cart.items.map(i => String(i.product_id)));
    const affinity = new Set();
    for (const item of cart.items) {
      const match = catalog.find(p => String(p.productId) === String(item.product_id));
      if (match?.category) affinity.add(match.category);
      const title = String(item.product_title || '').toLowerCase();
      if (/caff[eè]|coffee|cioccolat|chocolate|biscott|panetton|dolci/.test(title)) affinity.add('sweet');
      if (/caponata|agrodolce|olio|olive oil|pasta|sugo|pesto|conserv/.test(title)) affinity.add('savoury');
    }
    const families = context.families || {};
    let eligible = 0;
    let known = true;
    for (const item of cart.items) {
      if (item.requires_shipping === false) continue;
      const key = String(item.product_id);
      if (!Object.prototype.hasOwnProperty.call(families, key)) { known = false; continue; }
      if (families[key] === 'unknown') { known = false; continue; }
      if (!families[key]) eligible += Math.max(0, Number(item.final_line_price ?? item.line_price ?? 0));
    }
    const measurable = known && context.allowed && !context.zoneCheck && context.threshold > 0;
    const remaining = measurable ? Math.max(0, context.threshold - eligible) : null;
    const score = p => remaining > 0
      ? (p.price >= remaining ? p.price - remaining : 100000 + remaining - p.price)
      : p.price;
    const candidates = catalog.filter(p => p.available && p.price > 0 && !present.has(String(p.productId)));
    const related = candidates.filter(p => affinity.has(p.category));
    const pool = affinity.size === 1 && related.length >= 2 ? related : candidates;
    const items = pool
      .sort((a, b) => score(a) - score(b)).slice(0, 3);
    return {items, remaining};
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {recommend};
  if (typeof document === 'undefined') return;
  const start = () => {
    const section = document.querySelector('[data-sicilus-aov]');
    if (!section || section.dataset.started) return;
    section.dataset.started = 'true';
    let catalog;
    try { catalog = JSON.parse(section.querySelector('[data-aov-catalog]').textContent); } catch { return; }
    const text = JSON.parse(section.querySelector('[data-aov-copy]').textContent);
    const route = (root.Shopify?.routes?.root || '/');
    let serial = 0;
    let timer;
    let renderedKey = '';
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'it', {style:'currency',currency:'EUR'}).format(cents / 100);
    const update = async () => {
      const current = ++serial;
      try {
        const response = await fetch(route + 'cart.js', {credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if (!response.ok) { if (current === serial) section.hidden = true; return; }
        const cart = await response.json();
        if (current !== serial) return;
        const bar = document.querySelector('#sicilus-cart-shipping-bar-section [data-sicilus-free-shipping-bar]');
        let ownContext = null;
        try { ownContext = JSON.parse(section.querySelector('[data-aov-context]')?.textContent || 'null'); } catch {}
        let families = {};
        try { families = JSON.parse(document.getElementById('sicilus-cart-family-map')?.textContent || '{}'); } catch {}
        const result = recommend(catalog, cart, ownContext || {
          families, allowed:bar?.getAttribute('data-promo-country') === 'true',
          zoneCheck:bar?.getAttribute('data-requires-zone-check') === 'true',
          threshold:Number(bar?.getAttribute('data-threshold-eur') || 0)
        });
        const nextKey = JSON.stringify(result);
        if (nextKey === renderedKey) { section.hidden = !result.items.length; return; }
        const list = section.querySelector('[data-aov-list]');
        list.replaceChildren();
        for (const item of result.items) {
          const article = document.createElement('article');
          const link = document.createElement('a');
          link.href = item.url;
          const image = document.createElement('img');
          image.src = item.image; image.alt = item.title; image.loading = 'lazy'; image.width = 240; image.height = 240;
          const title = document.createElement('h3'); title.textContent = item.title;
          link.append(image, title);
          const price = document.createElement('p'); price.textContent = money(item.price);
          const form = document.createElement('form'); form.method = 'post'; form.action = route + 'cart/add';
          const variant = document.createElement('input'); variant.type = 'hidden'; variant.name = 'id'; variant.value = item.variantId;
          const quantity = document.createElement('input'); quantity.type = 'hidden'; quantity.name = 'quantity'; quantity.value = '1';
          const returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; returnTo.value = location.pathname + location.search;
          const submit = document.createElement('button'); submit.type = 'submit'; submit.textContent = text.add;
          form.append(variant, quantity, returnTo, submit); article.append(link, price, form); list.append(article);
        }
        section.querySelector('[data-aov-message]').textContent = result.remaining > 0
          ? text.remaining.replace('{amount}', money(result.remaining)) : text.intro;
        renderedKey = nextKey;
        section.hidden = !result.items.length;
      } catch { /* Hide on a failed read rather than show stale prices or a shipping claim. */ if (current === serial) section.hidden = true; }
    };
    const schedule = () => { clearTimeout(timer); timer = setTimeout(update, 450); };
    ['cart:update','cart:refresh','cart:reload','product:added'].forEach(name => document.addEventListener(name, schedule));
    document.addEventListener('change', event => { if (event.target.closest('#hdt-page-cart,cart-items-component,.hdt-cart,[data-cart]')) schedule(); }, true);
    document.addEventListener('click', event => { if (event.target.closest('#hdt-page-cart,cart-items-component,.hdt-cart,[data-cart]')) { schedule(); setTimeout(update, 1200); } }, true);
    root.addEventListener('pageshow', update);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})(typeof window !== 'undefined' ? window : {});
